import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

//import general components
import BaseRating from "../../../common/base-rating/base-rating";

//import images and icons
import { Star1 } from "iconsax-react";

function HotelInformation({ selectedHotel }) {
    const { t } = useTranslation();
    return (
        <Grid className="confirm__hotel" container item xs={12}>
            <Grid className="confirm__name" container item xs={12} columnGap={1}>
                {(selectedHotel?.type || t("hotel")) + " " + selectedHotel?.name}
                <BaseRating value={selectedHotel?.star} icon={Star1} emptyIcon={Star1} color="var(--golden-color)" size="16" readOnly={true} />
            </Grid>

            <Grid className="confirm__address" container item xs={12}>
                {selectedHotel?.address}
            </Grid>
        </Grid>
    );
}

export default HotelInformation;
